export const safeApiCall = async (apiFunc, fallback, onError) => {
  try {
    const res = await apiFunc();
    return res;
  } catch (error) {
    if (fallback !== undefined) return fallback;
    if (onError) onError(error);
    throw error;
  }
};